import request from '../request'
import download from '@/api/download'

export function fetchIncomeDetailList(params) {
    return request({
        url: '/finance-service/income-detail/list',
        method: 'get',
        params
    });
}

export function importIncomeDetail(file) {
    const formData = new FormData();
    formData.append('file', file);
    return request({
        url: '/finance-service/income-detail/import',
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
    });
}

export function exportIncomeDetail(data) {
    return download({
        url: '/finance-service/income-detail/export',
        method: 'post',
        data
    });
}

export function downloadIncomeDetailTemplate() {
    return download({
        url: '/finance-service/income-detail/template',
        method: 'get'
    });
}

export function updateIncomeDetail(data) {
    return request({
        url: '/finance-service/income-detail/update',
        method: 'post',
        data
    });
}

export function getTotalByContract(params) {
    return request({
        url: '/finance-service/income-detail/total-by-contract',
        method: 'get',
        params
    });
}
